import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatCurrency } from './utils';
import DetailAppraisalSection from './DetailAppraisalSection';

interface DetailSection9Props {
  submission: CreditSubmission;
}

export default function DetailSection9({ submission }: DetailSection9Props) {
  if (!submission.collateral_info || Object.keys(submission.collateral_info).length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>9. Agunan</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          {Object.entries(submission.collateral_info).map(([key, value]: [string, any]) => {
            // Skip if it's an array or complex object
            if (
              Array.isArray(value) ||
              (typeof value === 'object' && value !== null && !(value instanceof Date))
            ) {
              return null;
            }

            // Format currency for amount fields
            const isAmountField =
              key.includes('amount') ||
              key.includes('value') ||
              key.includes('price') ||
              key.includes('nilai');
            const displayValue =
              isAmountField && typeof value === 'number'
                ? formatCurrency(value)
                : String(value || '-');

            return (
              <div key={key}>
                <label className="text-sm text-gray-600 capitalize">{key.replace(/_/g, ' ')}</label>
                <p className="font-medium mt-1">{displayValue}</p>
              </div>
            );
          })}
        </div>
        {submission.appraisal_data && Object.keys(submission.appraisal_data).length > 0 && (
          <DetailAppraisalSection appraisalData={submission.appraisal_data} />
        )}
      </CardContent>
    </Card>
  );
}
